import React from "react";
import "./Footer.css"

const Footer = () => {
    const userStyle = JSON.parse(sessionStorage.getItem("dataStyle"));

    const backgraundFooter = {
        background: `${userStyle?.data.footerColor}`,
        color: `${userStyle?.data.footerLetters}`,
    };
    return (
        <>
            <footer className="icon-section-login" style={backgraundFooter} >
                <div className="icon-login">
                    <lord-icon
                        src="https://cdn.lordicon.com/hjbsbdhw.json"
                        colors="primary:#6c16c7,secondary:#a866ee,tertiary:#b26836,quaternary:#bebebe"
                    >
                    </lord-icon>
                    <h4>{userStyle?.data.name}</h4>

                </div>
                <div className="icon-login">
                    <lord-icon
                        src="https://cdn.lordicon.com/okmiidnt.json"
                        colors="primary:#4f1091,secondary:#a866ee"
                    >
                    </lord-icon>
                    <h4> {userStyle?.data.email} </h4>
                </div>
            </footer>
        </>
    )


}

export default Footer

